import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const List = styled.ul`
    display: inline;

    &:after {
        content: ' ';
    }
`;

const Item = styled.li`
    display: inline;

    &:after {
        content: ', ';
    }

    &:last-child:after {
        content: '...';
    }
`;

export default class Preview extends React.PureComponent {
    static propTypes = {
        insurances: PropTypes.arrayOf(PropTypes.object).isRequired,
    };

    render() {
        const { insurances } = this.props;
        const carriers = insurances.slice(0, 3).map(carrier => (
            <Item key={carrier.id}>
                {carrier.name}
            </Item>
        ));
        return (
            <List>
                {carriers}
            </List>
        );
    }
}
